import DpMap from './DpMap.jsx';

export default () => {
    return {
        path: '/DpMap',
        element: <DpMap />,
    }
}